module.exports = function(app) {
    "use strict";
    app.controller('pages.employer.reports.requestedreports', ["$state", "$scope", "sessionData", "services", "$window", "invisibleFormService","storage",
        function ($state, $scope, sessionData, services, $window,invisibleFormService, storage) {

            var reportType = storage.get('reportType');
            $scope.isND = sessionData.employerInfo.brandName === '6011';
            var crumbs = {
                cenorwell: {
                    title: reportType === 'wellness' ? "Wellness Reports": "Census Reports",
                    state: "reports.censusOrWellness"
                },
                requested: {
                    title: "Requested Reports"

                }
            };
            $scope.$parent.sidebar = {
                breadCrumb: {
                    primary: {
                        title: "Reports",
                        state: "reports"
                    }
                }
            };

            if(!$scope.isND){
                $scope.$parent.sidebar.breadCrumb.secondary = crumbs.requested;

            } else if($scope.isND){
                $scope.$parent.sidebar.breadCrumb.secondary = crumbs.cenorwell;
                $scope.$parent.sidebar.breadCrumb.tertiary = crumbs.requested;
            }


            $scope.reports = {
                orderBy: 'requestDate',
                reverse: true,
                pagination: {
                    itemsPerPage: 10,
                    page: 1
                },
                titles: [
                    {
                        name: "Published",
                        dataKey: "requestDate"
                    },
                    {
                        name: "Title",
                        dataKey: "reportType",
                        selectAll: true
                    },
                    {
                        name: "Group Numbers",
                        dataKey: "groupNumbers"
                    },
                    {
                        name: "Format",
                        dataKey: "reportFormat"
                    },
                    {
                        name: "Request ID",
                        dataKey: "reportId"
                    }
                ],
                rows: []
            };
            loadRequestedReports();



            function loadRequestedReports() {
                services.eprsvc.censusReport().fetchRequestedReports(reportType).then(
                    function (response) {
                        // comment to make it build response.payload
                        var creport = response.data.payload;
                        if (creport.length > 0) {
                            for (var i = 0; i < creport.length; i++) {
                                $scope.reports.rows.push(creport[i]);
                            }
                        }

                    });
            }



            $scope.$watch("reports.selectAllRows",function(newValue,oldValue){
                if(oldValue!=newValue){
                    var filter=$scope.reports.rows.filterBy;
                    for(var index=0; index<$scope.reports.rows.length;index++){
                        var key= $scope.reports.rows[index].reportId;
                        if(key && (filter && (key.indexOf(filter)>=0 || filter.trim()==="")) || !filter){
                            // $scope.groupTableObj.groupAccessArray[index].selected=$scope.groupTableObj.selectAllRows;
                        }
                    }
                }
            },true);

            $scope.downloadReport = function (fileName, format) {
                console.log("download clicked");
                var fileType;
                var reportNam = reportType === 'wellness' ? "Wellness/": "census/"
                if(format === 'Excel'){
                    fileType = 'xlsx';
                }
                else {
                    fileType = 'pdf';
                }
                invisibleFormService.submit(
                    {
                        name: 'downloadReport',
                        method: 'GET',
                        action: '/eprsvc/x-services/secure/reports/v1/download/'+ reportNam + fileName + '.' + fileType,
                        target: '_self'
                    }
                );
            };







        }
    ]);
    return [
        {
            state: 'reports.requestedreports',
            url: '/requested-reports',
            postPassword: true,
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/hmhs/content-page.html'],
                    controller: 'pages.employer.reports.requestedreports'
                },
                'content@reports.requestedreports': {
                    templateUrl:'reports/requested-reports.employerTemplate.html/pages/reports/requestedReports'
                    //'reports/requested-reports.employerTemplate.html/pages/reports/requestedReports'
                    //template: require('pages/reports/requestedReports.html')

                }
            }
        }

    ];
};


